import React from 'react';
import './css/App.css';

import {RecoilRoot} from 'recoil';
import Cookies from "js-cookie";
import {customerKeyExists} from "./utils/requestUtils";
import AppRouter from "./AppRouter";
import {createRoot} from "react-dom/client";
import {ensureSessionIsActive} from "./utils/session";
import {disableAutocomplete} from "./utils/disableAutocomplete";

const currentUrl = window.location.href;

const urlParts = currentUrl.split('/');
const customerKey = urlParts.length > 1 ? urlParts[urlParts.length - 1] : undefined;
const lastUrlPart = urlParts.length > 1 ? urlParts[urlParts.length - 2] : undefined;

let customerKeyValid = false;

if (lastUrlPart.startsWith('autocadastro') && customerKey) {

    const response = await customerKeyExists(customerKey);

    if (response.valid) {
        customerKeyValid = true;
        Cookies.set('customerKey', customerKey);
    }
}

if (window.location.pathname === '/') {
    const targetPath = ensureSessionIsActive() ? '/app' : '/login';
    window.history.replaceState({}, '', targetPath);
}

disableAutocomplete();

createRoot(document.getElementById('root')).render(
    <RecoilRoot>
        {<AppRouter customerKeyValid={customerKeyValid}/>}
    </RecoilRoot>,
);


